import client from '../../client';
import {
  GET_OPERATOR_DATA,
  GET_OPERATOR_DATA_SUCCESS,
  GET_OPERATOR_DATA_FAIL,
  GET_ALL_OPERATOR_DATA,
  GET_ALL_OPERATOR_DATA_SUCCESS,
  GET_ALL_OPERATOR_DATA_FAIL
} from '../constants/operator';

export const getOperatorData = (params) => dispatch => {
  dispatch({
    type: GET_OPERATOR_DATA
  });

  client
    .get('/operators', { params })
    .then(res => {
      dispatch({
        type: GET_OPERATOR_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_OPERATOR_DATA_FAIL,
        error
      })
    });
}

export const getAllOperatorData = (params) => dispatch => {
  dispatch({
    type: GET_ALL_OPERATOR_DATA
  });

  client
    .get('/operators')
    .then(res => {
      dispatch({
        type: GET_ALL_OPERATOR_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ALL_OPERATOR_DATA_FAIL,
        error
      })
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/operator.js